export const APP_TITLE = process.env.REACT_APP_TITLE || ''
